import axios from '@axios'

const PREFIX = '/analiticos'

export default {

  getContadoresEmpresa(filtro) {
    return axios.post(`${PREFIX}/totalizadores/empresa`, filtro)
  },

  getContadoresCaixaPostal(filtros) {
    return axios.post(`${PREFIX}/totalizadores/caixa-postal`, filtros)
  },

  getContadoresCnd(filtros) {
    return axios.post(`${PREFIX}/totalizadores/cnd`, filtros)
  },

  getContadoresSituacaoFiscal(filtros) {
    return axios.post(`${PREFIX}/totalizadores/situacao-fiscal`, filtros)
  },

  getContadoresPendenciaSituacaoFiscal(filtros) {
    return axios.post(`${PREFIX}/totalizadores/pendencia-situacao-fiscal`, filtros)
  },

  getContadoresParcelamentosAtrasados(filtros) {
    return axios.post(`${PREFIX}/totalizadores/status-parcelamentos`, filtros)
  },

  getContadoresDctfWeb(ano, filtros) {
    return axios.post(`${PREFIX}/totalizadores/dctf-web?ano=${ano}`, filtros)
  },

  getTotalEmpresas() {
    return axios.get(`${PREFIX}/empresas`)
  },

  getTotalEmpresasFiltrado(id, body) {
    return axios.post(`${PREFIX}/empresas`, body)
  },
}
